const randomString = (size = 20) => {
  let result = ''
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let length = size
  while (length > 0) {
    length -= 1
    result += chars[Math.round(Math.random() * (chars.length - 1))]
  }
  return result
}

export default randomString
